import { useStoreState } from "pullstate";
import Store from "../../utils/Store";
import useMedia, { MediaSizes } from "../../hooks/useMedia";
import { useRouter } from "next/router";
import { useEffect } from "react";

const useSettings = () => {
  const isMobile = useMedia([MediaSizes.MOBILE], [true], false);
  const router = useRouter();
  const { isSettingsOpen, selectedSetting, hasUnsavedSetting } = useStoreState(
    Store,
    (s) => ({
      isSettingsOpen: s.isSettingsOpen,
      hasUnsavedSetting: s.hasUnsavedSetting,
      selectedSetting: s.selectedSetting,
      settingPageNo: s.settingPageNo,
    })
  );

  useEffect(() => {
    if (!isSettingsOpen) {
      Store.update((s) => {
        s.settingParams = {};
      });
    }
  }, [isSettingsOpen]);

  const openSetting = (pageName: string, params: Record<any, any> = {}) => {
    let _isSettingsOpen = isSettingsOpen;
    let _selectedSetting = selectedSetting;
    if (isMobile) {
      router.push(`/settings/${pageName}`);
    } else {
      _isSettingsOpen = true;
      _selectedSetting = pageName;
    }
    Store.update((s) => {
      s.isSettingsOpen = _isSettingsOpen;
      s.selectedSetting = _selectedSetting;
      s.settingParams = params;
    });
  };

  return { isSettingsOpen, hasUnsavedSetting, openSetting };
};

export default useSettings;
